import DndRegistrationService from "../services/dnd-registration.service";
import { DndRegistrationActionType } from "../actiontype/dnd-registration.actiontype";
import { showLoader, hideLoader } from "./app.action";
import { openPage } from "./dnd-app.action";
import { openErrorModal } from "./app-modal.action";
import Page from "../constants/page.enum";
import UtilService from "../services/util.service";
import { AppModalConstant } from "../constants/app-modal.constant";

//fetch dnd preferences
export const fetchDndMappingAndPreferences = () => (dispatch, getState) => {
    const state = getState();

    const msisdn = state.userInfo.selectedNumber;

    dispatch(showLoader());
    dispatch(fetchDndMappingAndPreferencesLoading());
    DndRegistrationService.fetchDndMappingAndPreferences(msisdn).then(
        res => {
            dispatch(hideLoader());
            dispatch(fetchDndMappingAndPreferencesSuccess(res));
            const dndPreferencesResponse = res[0] && res[0]['data'] && res[0]['data']['data'] ? res[0]['data']['data'] : '';
            dispatch(setDndPreferencesResponse(dndPreferencesResponse));
            const dndMappingResponse = res[1] && res[1]['data'] && res[1]['data']['data'] ? res[1]['data']['data'] : '';
            dispatch(setDndMappingResponse(dndMappingResponse));
            dispatch(createRegistrationPreferenceList());
            dispatch(autoSelectRegistrationPreferences(null));
            dispatch(createCategorywiseSelectedPreferenceList());
            dispatch(openPage(Page.REGISTRATION_FORM));
        },
        error => {
            dispatch(hideLoader());
            dispatch(fetchDndMappingAndPreferencesError(error));
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    )
}

//fetch DND mapping
export const fetchDndMapping = () => dispatch => {
    dispatch(showLoader());
    dispatch(fetchDndMappingLoading());
    DndRegistrationService.fetchDndMapping().then(
        res => {
            dispatch(hideLoader());
            if (res && res['data'] && res['data']['data']) {
                const data = res['data']['data'];
                dispatch(fetchDndMappingSuccess(res));
                //Filtering dnd mapping response based on field category as Complaint flow needs to display only categories.
                const dndMappingResponse = DndRegistrationService.fetchDndCategoryMapping(data);
                dispatch(setDndMappingResponse(dndMappingResponse));
                dispatch(openPage(Page.COMPLAINT_FORM));
            }
            else {
                dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
            }
        },
        error => {
            dispatch(hideLoader());
            dispatch(fetchDndMappingError(error));
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    )
}

//Map DND Preferences with DND Mapping file
export const createRegistrationPreferenceList = () => (dispatch, getState) => {
    const state = getState();
    const dndPreferences = state.registrationInfo.dndPreferences;
    const dndMapping = state.registrationInfo.dndMapping;
    const preference = state.dndapp.userPreference;

    if ((dndMapping && dndMapping.length) && (dndPreferences)) {
        let selectedPreferenceList = {};
        const preferenceList = dndMapping;

        selectedPreferenceList = DndRegistrationService.createRegistrationPreferenceList(dndMapping, dndPreferences, preference);
        dispatch(setSelectedPreferenceList(selectedPreferenceList));
        dispatch(setPreferenceList(preferenceList));
    }
    else {
        dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
    }
}

//Auto-select the preferences on basis of BLOCK ALL, BLOCK PROMO or ALL TIME/DAY/MODE 
export const autoSelectRegistrationPreferences = (source) => (dispatch, getState) => {
    const state = getState();
    let selectedPreferenceList = state.registrationInfo.selectedPreferenceList;
    selectedPreferenceList = DndRegistrationService.getAutoSelectedRegistrationPreferencesList(selectedPreferenceList, source);
    const enableMorePreferences = DndRegistrationService.enableMorePreferences(selectedPreferenceList);
    dispatch(setEnableMorePreferences(enableMorePreferences));
    if (!enableMorePreferences) {
        dispatch(closeMorePreferences());
    }
    dispatch(setSelectedPreferenceList(selectedPreferenceList));
}

export const createCategorywiseSelectedPreferenceList = () => (dispatch, getState) => {
    const state = getState();
    const selectedPreferenceList = state.registrationInfo.selectedPreferenceList;
    const categorywiseSelectedPreferenceList = DndRegistrationService.getCategorywiseSelectedPreferenceList(selectedPreferenceList);
    dispatch(setCategorywiseSelectedPreferenceList(categorywiseSelectedPreferenceList));
}

//Submit Registration (MOBILE/LANDLINE)
export const submitPreferences = () => (dispatch, getState) => {
    const state = getState();
    const msisdn = state.userInfo.selectedNumber;
    const dndPreferences = state.registrationInfo.dndPreferences;
    const selectedPreferenceList = state.registrationInfo.selectedPreferenceList;
    const selectedPreferenceObj = DndRegistrationService.createRegistrationRequest(selectedPreferenceList);
    const platformType = state.app.platformType;
    const rmode = platformType['rmode'];
    const reqData = {
        msisdn: msisdn,
        rmode: rmode,
        cmode: (selectedPreferenceObj && selectedPreferenceObj['cmode'] && selectedPreferenceObj['cmode'].length !== -1) ? selectedPreferenceObj['cmode'] : [],
        ctgr: (selectedPreferenceObj && selectedPreferenceObj['ctgr'] && selectedPreferenceObj['ctgr'].length !== -1) ? selectedPreferenceObj['ctgr'] : [],
        day: (selectedPreferenceObj && selectedPreferenceObj['day'] && selectedPreferenceObj['day'].length !== -1) ? selectedPreferenceObj['day'] : [],
        time: (selectedPreferenceObj && selectedPreferenceObj['time'] && selectedPreferenceObj['time'].length !== -1) ? selectedPreferenceObj['time'] : []
    }
    // reqData.push(reqObj);
    dispatch(showLoader());
    dispatch(dndRegistrationLoading());
    DndRegistrationService.dndRegistrationSubmit(reqData).then(
        res => {
            dispatch(hideLoader());
            if (res && res['data'] && res['data']['data']) {
                const response = res['data']['data'];
                if (response['success']) {
                    dispatch(dndRegistrationSuccess(response));
                    dispatch(openPage(Page.MOBILE_REGISTRATION_SUCCESS));
                }
                else {
                    dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
                }
            }
            else {
                dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
            }
        },
        error => {
            dispatch(hideLoader());
            dispatch(dndRegistrationError(error));
            dispatch(openErrorModal(AppModalConstant.GENERIC_ERROR_MESSAGE));
        }
    )
}

//toggle advance 
export function toggleAdvance() { return { type: DndRegistrationActionType.TOGGLE_ADVANCE } };

//set Final preference list
function setPreferenceList(response) { return { type: DndRegistrationActionType.SET_PREFERENCE_LIST, payload: response } };
export function setSelectedPreferenceList(response) { return { type: DndRegistrationActionType.SET_SELECTED_PREFERENCE_LIST, payload: response } };

//set category wise preference list
function setCategorywiseSelectedPreferenceList(categorywiseSelectedPreferenceList) { return { type: DndRegistrationActionType.SET_CATEGORY_WISE_PREFERENCE_LIST, payload: categorywiseSelectedPreferenceList } }

//set dnd preferences (already selected by user)
function setDndPreferencesResponse(response) { return { type: DndRegistrationActionType.SET_DND_PREFERENCES, payload: response } };

//set dnd mapping (static data from BE)
function setDndMappingResponse(response) { return { type: DndRegistrationActionType.SET_DND_MAPPING, payload: response } };

//set enable more preferences
function setEnableMorePreferences(enableMorePreferences) { return { type: DndRegistrationActionType.ENABLE_MORE_PREFERENCES, payload: enableMorePreferences } }

//close more preferences section
function closeMorePreferences() { return { type: DndRegistrationActionType.CLOSE_ADVANCE } }

//set api calls status 
//fetch dnd registration preference api status
function fetchDndMappingAndPreferencesLoading() { return { type: DndRegistrationActionType.FETCH_DND_MAPPING_AND_PREFERENCES_LOADING } };
function fetchDndMappingAndPreferencesSuccess(response) { return { type: DndRegistrationActionType.FETCH_DND_MAPPING_AND_PREFERENCES_SUCCESS, payload: response } };
function fetchDndMappingAndPreferencesError(error) { return { type: DndRegistrationActionType.FETCH_DND_MAPPING_AND_PREFERENCES_ERROR, payload: error } };
//fetch dnd mapping api status
function fetchDndMappingLoading() { return { type: DndRegistrationActionType.FETCH_DND_MAPPING_LOADING } };
function fetchDndMappingSuccess(response) { return { type: DndRegistrationActionType.FETCH_DND_MAPPING_SUCCESS, payload: response } };
function fetchDndMappingError(error) { return { type: DndRegistrationActionType.FETCH_DND_MAPPING_ERROR, payload: error } };
//submit dnd registration mobile api status
function dndRegistrationLoading() { return { type: DndRegistrationActionType.DND_REGISTRATION_MOBILE_LOADING } };
function dndRegistrationSuccess(response) { return { type: DndRegistrationActionType.DND_REGISTRATION_MOBILE_SUCCESS, payload: response } };
function dndRegistrationError(error) { return { type: DndRegistrationActionType.DND_REGISTRATION_MOBILE_ERROR, payload: error } };
